import React, { useState }  from 'react';
import './App.css';
import './styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

function ShoppingCart(){
  const [isCartOpen, setIsCartOpen] = useState(false);

  const items = [
    { name: 'Shirt', quantity: 1, price: 2599.00 },
    { name: 'Jeans', quantity: 2, price: 3999.00 },
    { name: 'Watches', quantity: 1, price: 4999.00 },
    { name: 'Belt', quantity: 1, price: 1599.00 },
    { name: 'Wallet', quantity: 1, price: 1999.00 },
  ];

  const total = items.reduce((acc, item) => acc + item.price * item.quantity, 0);

  const openCart = () => {
    setIsCartOpen(true);
  };

  const closeCart = () => {
    setIsCartOpen(false);
  };

  return (
    <div className="shopping-cart">
      <i className={`fa fa-shopping-cart ${isCartOpen ? 'active' : ''}`} onClick={openCart}></i>

      {isCartOpen && (
        <div className="cart-dropdown">
          <h3>Your Shopping Cart</h3>
          <ul className="cart-items">
            {items.map((item, index) => (
              <li key={index}>
                {item.name} (Qty: {item.quantity}) - ₹{item.price.toFixed(2)}
              </li>
            ))}
          </ul>
          <p>Total: ₹{total.toFixed(2)}</p>
          <button className="checkout-button" onClick={closeCart}>
            Checkout
          </button>
        </div>
      )}
    </div>
  );
};

function About() {
  return (
    <section id="about" className="py-5">
      <div className="container">
        <h1 className='fashalien' style={{textAlign:"center"}}>About FashAlien: Your Ethical Fashion Destination</h1>
        <div className="philosophy card text-dark-50" style={{backgroundColor:"#FDF5E6"}}>
          <div className="card-body">
            <h2>Our Eco-Friendly Philosophy:</h2>
            <p className='personal' style={{color:"black"}}>
              FashAlien was born out of a commitment to environmental responsibility and a deep understanding of the fashion industry's impact on our planet. We believe that fashion can be beautiful and ethical simultaneously. That's why our ethos centers around sustainable, eco-friendly practices.
            </p>
          </div>
        </div>
        <div className="journey card bg-info text-dark-50">
          <div className="card-body">
            <h2>Our Journey:</h2>
            <p className='personal' style={{color:"black"}}>
            FashAlien was founded in 2020, and from our very inception, we set out to create a fashion haven where style meets sustainability. Our journey has been guided by a deep-rooted passion for ethical fashion, a desire to reduce waste, and a commitment to fair labor practices.</p>
          </div>
        </div>
        <div className="experience card bg-warning text-dark-50">
          <div className="card-body">
            <h2>The FashAlien Experience:</h2>
            <p className='personal' style={{color:"black"}}>
            When you shop at FashAlien, you're not just purchasing clothes; you're supporting a movement. Our fashion pieces are meticulously curated from sustainable sources, featuring organic and environmentally-friendly materials. Each product in our collection tells a story of responsible craftsmanship.
            </p>
          </div>
        </div>
        <div className="movement card bg-success text-light">
          <div className="card-body">
            <h2>Join the FashAlien Movement:</h2>
            <p className='personal' style={{color:"white"}}>
              We invite you to join us on our journey towards a more beautiful and eco-friendly world. FashAlien is more than a fashion store; it's a call to action. Let's make the world more beautiful and handsome, one eco-friendly garment at a time. Shop with us, support sustainability, and be a part of the change.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function Dashboard() {
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [showSpendAnalytics, setShowSpendAnalytics] = useState(false);
  const [showPreferredBrands, setShowPreferredBrands] = useState(false);
  const [orderDetails, setOrderDetails] = useState([]);
  const [spendAnalytics, setSpendAnalytics] = useState([]);
  const preferredBrands = ['Nike', 'Reebok', 'Bata', 'Raymonds', 'Gucci', 'Allen Solly', 'Levis', 'Jockey'];

  // Function to generate random order details
  const generateRandomOrders = () => {
    const orders = [];
    for (let i = 1; i <= 5; i++) {
      const orderId = Math.floor(1000 + Math.random() * 9000); // Random 4-digit order ID
      const orderDate = new Date(2023, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1).toLocaleDateString(); // Random date in 2023
      const orderDelivered = Math.random() < 0.5; // Randomly true or false for order delivered
      orders.push({ orderId, orderDate, orderDelivered });
    }
    setOrderDetails(orders);
  };

  // Function to generate random spend analytics
  const generateSpendAnalytics = () => {
    const analytics = [
      { item: "Shirts", amount: (Math.random() * 5000).toFixed(2) },
      { item: "Jeans", amount: (Math.random() * 5000).toFixed(2) },
      { item: "Accessories", amount: (Math.random() * 5000).toFixed(2) },
      { item: "Kids Clothing", amount: (Math.random() * 5000).toFixed(2) },
      { item: "Dresses", amount: (Math.random() * 5000).toFixed(2) },
    ];
    setSpendAnalytics(analytics);
  };  

  return (
    <section id="dashboard" className="py-5">
      <div className="container">
        <h1 className='shubh' style={{ textAlign: "center" }}>Dashboard</h1>
        <div className="row">
          <div className="col-md-4 mb-4">
            <div className="card">
              <img src="/images/orderhistory.jpg" className="card-img-top" alt="Order History" />
              <div className="card-body1">
                <h3 className="card-title">Order History</h3>
                <p className="card-text">Click the button below to explore your order history.</p>
                <a onClick={() => { generateRandomOrders(); setShowOrderDetails(!showOrderDetails); }} className="btn btn-danger" style={{color:"aliceblue"}}>
                  Explore Order History
                </a>
                {showOrderDetails && (
                  <div className="order-details-container">
                    <h3>Order History Details</h3>
                    <ul className="order-details-list">
                      {orderDetails.map((order, index) => (
                        <li key={index}>
                          Order ID: {order.orderId}<br />
                          Order Date: {order.orderDate}<br />
                          Order Delivered: {order.orderDelivered ? 'Yes' : 'No'}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card">
              <img src="/images/spend.jpg" className="card-img-top" alt="Spend Analytics" />
              <div className="card-body1">
                <h3 className="card-title">Spend Analytics</h3>
                <p className="card-text">Click the button below to view your spend analytics.</p>
                <a onClick={() => { generateSpendAnalytics(); setShowSpendAnalytics(!showSpendAnalytics); }} className="btn btn-primary" style={{color:"aliceblue"}}>
                  Explore Spend Analytics
                </a>
                {showSpendAnalytics && (
                  <div className="spend-analytics-container">
                    <h3>Spend Analytics Details</h3>
                    <ul className="spend-analytics-list">
                      {spendAnalytics.map((item, index) => (
                        <li key={index}>
                          {item.item} - ₹{item.amount}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card">
              <img src="/images/brands.jpg" className="card-img-top" alt="Most Preferred Brands" />
              <div className="card-body1">
                <h3 className="card-title">Most Preferred Brands</h3>
                <p className="card-text">Click the button below to view the most preferred brands.</p>
                <a onClick={() => setShowPreferredBrands(!showPreferredBrands)} className="btn btn-success" style={{color:"aliceblue"}}>
                  Explore Preferred Brands
                </a>
                {showPreferredBrands && (
                  <div className="preferred-brands-container">
                    <h3>Preferred Brands</h3>
                    <ul className="preferred-brands-list">
                      {preferredBrands.map((brand, index) => (
                        <li key={index}>
                          {brand}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="App">
      <header>
      <nav className="navbar navbar-expand-md navbar-dark">
      <div className="container">
      <a className="navbar-brand" href="/">FashAlien</a>
        <button className="navbar-toggler" type="button" onClick={toggleMenu}>
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <a className="nav-link" href="#home">Home</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#about">About Us</a>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="fashionDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Fashion For
            </a>
            <div className="dropdown-menu" aria-labelledby="fashionDropdown">
              <a className="dropdown-item" href="#fashionfor">Men</a>
              <a className="dropdown-item" href="#fashionfor">Women</a>
              <a className="dropdown-item" href="#fashionfor">Kids</a>
              <a className="dropdown-item" href="#fashionfor">Accessories</a>
            </div>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#dashboard">Dashboard</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#contact">Contact</a>
          </li>
          <li className="nav-item">
            <ShoppingCart />
          </li>
        </ul>
        </div>
      </div>
    </nav>
  </header>

      <main>
        <section id="home" className="py-5">
          <div className="container">
            <h1 className="display-4"><i className="fa fa-shirt" style={{color:"green"}}></i>Welcome to FashAlien!<i className="fa fa-leaf" style={{color:"green"}}></i></h1>
            <p className="lead">Welcome to our eco-conscious fashion world!
            At our e-commerce platform, we're more than just a clothing store; we're on a mission to make the world a more beautiful and eco-friendly place for everyone.
            We believe in fashion that doesn't cost the earth, and we offer the latest trends for men, women, and kids alike. From trendy youngsters to elegant seniors, we've got something for every age and style.
            Our collections aren't just about looking good; they're about feeling good too. By choosing us, you're choosing fashion that cares for the planet and the people on it. Together, we can make the world more beautiful and handsome, one eco-friendly garment at a time.</p>
            <img src="/images/home.jpg" alt="Home" className="home-image" style={{ width: "900px", height: "500px", objectFit: "cover" }}/>
          </div>
        </section>

        <About />

        <section id="fashionfor" className="py-4">
        <div className="container">
          <h1 className="fashionfor" style={{ textAlign: "center" }}>
            Fashion For:
          </h1>
          <Carousel showThumbs={false} showStatus={false} infiniteLoop autoPlay interval={1500}>
            <div>
            <a href="https://www.snitch.co.in/collections/all" target="_blank">
              <img src="/images/men.jpg" alt="Men" />
              <p className="legend" id='fashionformen'>Men</p>
              </a>
            </div>
            <div>
            <a href="https://www.nykaafashion.com/women/c/6557?root=topnav_1&f=category_filter%3D10_156_164_3907_3908_4543_5040_647_6498_652_662_69_7555_7630_8522_9729_" target="_blank">
              <img src="/images/women.jpg" alt="Women" />
              <p className="legend" id='fashionforwomen'>Women</p>
              </a>
            </div>
            <div>
            <a href="https://www.firstcry.com/boutique/cute-as-a-button-up-to-6y/31252?ref2=homepage" target="_blank">
              <img src="/images/kids.jpg" alt="Kids" />
              <p className="legend" id='fashionforkids'>Kids</p>
              </a>
            </div>
            <div>
            <a href="https://www.myntra.com/accessories?f=Categories%3AWatches" target="_blank">
              <img src="/images/accessories.jpg" alt="Accessories" />
              <p className="legend" id='fashionforaccessories'>Accessories</p>
              </a>
            </div>
          </Carousel>
        </div>
      </section>

      <Dashboard/>

        <section id="contact" className="py">
          <div className="container">
          <h1 className='shubh' style={{textAlign:"center"}}>Contact Us</h1>
            <p>Whether you're looking to shop for the latest eco-friendly fashion trends, explore partnership opportunities, or inquire about our return and exchange policy, our e-commerce website is the gateway to all your FashAlien needs. We're most welcome to receive your feedback as we strive to create a sustainable and stylish future together.</p>
            <div className="row">
              <div className="col-md-6">
                <h3>Email</h3>
                <p>fashalien@gmail.com</p>
              </div>
              <div className="col-md-6">
                <h3>Phone</h3>
                <p>+91 9701000640</p>
              </div>
              <div className="col-md-12">
                <h3>Address</h3>
                <p>4-6-503/504, Esamiya Bazar, Koti, Hyderabad, Telangana, India</p>
                <p>Pin Code: 500027</p>
              </div>
            </div>
            <h2 style={{fontFamily:'Big Shoulders Text'}}>Thank you for being a FashAlien and for choosing ethical fashion with us!</h2>
          </div>
        </section>
      </main>

      <footer className="text-center py-3">
        <p>&copy; FashAlien</p>
      </footer>
    </div>
  );
}

export default App;